import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Experience } from './experience.model';

@Injectable({
  providedIn: 'root'
})
export class ExperiencesService {

  constructor(private http: HttpClient) { }

  addNewExperience(newExp): Observable<any> {
    return this.http.post(environment.apiUrl + '/experience/new', newExp);
  }

  getAllExperiences(): Observable<any> {
    return this.http.get(environment.apiUrl + '/experience/getAll');
  }

  getOneExperience(id: string | number): Observable<any> {
    return this.http.get(environment.apiUrl + '/experience/getSingle/' + id);
  }

  addInteractionToExperience(intId: number | string, expId: number | string): Observable<any> {
    return this.http.post(environment.apiUrl + '/experience/addInteraction', {interactionId: intId, experienceId: expId});
  }

  deleteInteractionFromExperience(intId: number | string): Observable<any> {
    return this.http.delete(environment.apiUrl + '/experience/deleteFromExperience/' + intId);
  }
  
  deleteGroupFromExperience(groupId: number | string): Observable<any> {
    return this.http.delete(environment.apiUrl + '/group/delete/' + groupId);
  }

  setInteractionsOrder(intOrder: {experienceId: number, interactionId: number, order: number}[]): Observable<any> {
    return this.http.put(environment.apiUrl + '/experience/setIntExpData', {interactionsOrder: JSON.stringify(intOrder)});
  }

  setInteractionsPoints(interactionPoints: {experienceId: number, interactionId: number, points: number, id: number}[]): Observable<any> {
    return this.http.put(environment.apiUrl + '/experience/setInteractionsPoints', {interactionPoints: JSON.stringify(interactionPoints)});
  }

  setPrizesScore(prizesScore: {experienceId: number, prizeId: number, score: number}[]): Observable<any> {
    return this.http.put(environment.apiUrl + '/experience/setPrizeScore', {prizesScore: JSON.stringify(prizesScore)});
  }

  editExperience(experience: Experience): Observable<any> {
    return this.http.put(environment.apiUrl + '/experience/edit', experience);
  }

  setExperienceToOnline(originalId: number, tempId: number): Observable<any> {
    return this.http.post(environment.apiUrl + '/experience/setExperienceToOnline', {originalId: originalId, tempId: tempId });
  }

  changeStatus(id: number, status: string): Observable<any> {
    return this.http.put(environment.apiUrl + '/experience/changeStatus', {experienceId: id, status: status});
  }

  deleteTemporary(tempId: number, originalId: number): Observable<any> {
    return this.http.delete(environment.apiUrl + '/experience/deleteTemporary/' + tempId + '/' + originalId);
  }

  getExpTree(expId: number) : Observable<any> {
    return this.http.get(environment.apiUrl + '/experience/getTree/' + expId);
  }

  editIntOrGroupOrder(expId: number, newOrder: number[]) : Observable<any> {
    return this.http.post(environment.apiUrl + '/experience/editOrder', {experienceId: expId, newOrder: newOrder});
  }

  getMaxPoints(expId: number) : Observable<any> {
    return this.http.get(environment.apiUrl + '/experience/getMaxPoints/' + expId);
  }

  addIntOrGroupToExp(expId: number, intId?: number, groupId?: number, order?: number): Observable<any> {
    return this.http.post(environment.apiUrl + '/experience/addToExperience/', {experienceId: expId, interactionId: intId, groupId: groupId, order: order});
  }

  getIntDetails(intId: number): Observable<any> {
    return this.http.get(environment.apiUrl + '/experience/getInteractionDetails/' + intId);
  }

  editInteractionDetails(intId: number, rightAnswer: string, wrongAnswer: string, rightImage: string, wrongImage: string, timeLimit: number, points: number, extra: any): Observable<any> {
    return this.http.patch(environment.apiUrl + '/experience/editInteractionDetails/', {id: intId, rightAnswer: rightAnswer, wrongAnswer: wrongAnswer, rightImage: rightImage, wrongImage: wrongImage, timeLimit: timeLimit, points: points, extra: extra});
  }

  addNewGroup(expId: number, title: string, parentId: number): Observable<any> {
    return this.http.post(environment.apiUrl + '/group/new/', {experienceId: expId, title: title, parentId: parentId});
  }

  getGroup(id: number): Observable<any> {
    return this.http.get(environment.apiUrl + '/group/' + id);
  }

  editGroup(group: any): Observable<any> {
    return this.http.put(environment.apiUrl + '/group/edit', group);
  }

  updateMapData(interactions): Observable<any> {
    return this.http.patch(environment.apiUrl + '/experience/updateMapData', {mapData: JSON.stringify(interactions)});
  }

}
